jQuery('.owl-carousel').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 2
        },
        860: {
            items: 3
        },
        1087: {
            items: 4
        },
        1500: {
            items: 5
        }
    }
});